function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/*
 * @Author: Wolf.Ma
 * @Date: 2023-08-23 14:13:04
 * @LastEditors: Do not edit
 * @LastEditTime: 2023-10-11 10:03:08
 * @FilePath: /njoy-design/src/njoyInput/index.tsx
 * @Description:
 */
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { ConfigProvider, Input, Space } from 'antd';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { antdTheme, njoydTheme } from "../theme";
import "./styles/index.less";
var regTypes = {
  number: /[^\d]/g,
  // 数字
  chinese: /[^\u4e00-\u9fa5]/g,
  // 汉字
  str: /[^a-zA-Z]/g,
  // 英文
  strNum: /[^A-Za-z0-9]/g,
  // 英文数字
  str_num: /[^a-zA-Z0-9\u0020-\u007F]/g,
  // 英文数字特殊字符
  text: '',
  // 无限制
  phone: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
  // 手机号
  tel: /^(?:(?:\d{3}-)?\d{8}|^(?:\d{4}-)?\d{7,8})(?:-\d+)?$/,
  // 座机号  eg: 0341-86091234
  url: /^((https?|ftp|file):\/\/)?([\da-z\\.-]+)\.([a-z\\.]{2,6})([\\/\w \\.-]*)*\/?$/,
  // URL
  idCard: /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0[1-9]|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/,
  // 身份证号, 支持1/2代(15位/18位数字)
  email: /^([a-zA-Z]|[0-9])(\w|\\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/ // 邮箱
};
// 能够限制输入框输入的类型
var canLimitInput = ['number', 'chinese', 'str', 'strNum', 'str_num'];
// 校验提示
var verifyTips = {
  phone: '请输入正确的手机号',
  tel: '请输入正确的座机号码',
  url: '请输入正确的url',
  idCard: '请输入正确的身份证号码',
  email: '请输入正确的邮箱'
};
var isComposition = false;
var NjInput = function NjInput(props) {
  // antd 原生主题对象
  var antd = antdTheme();
  // njoyd 原生主题对象
  var njoyd = njoydTheme();
  var value = props.value,
    reg = props.reg,
    _props$regtips = props.regtips,
    regtips = _props$regtips === void 0 ? '' : _props$regtips,
    style = props.style,
    _props$regtype = props.regtype,
    regtype = _props$regtype === void 0 ? 'text' : _props$regtype,
    suffix = props.suffix,
    _props$showlength = props.showlength,
    showlength = _props$showlength === void 0 ? false : _props$showlength,
    _props$maxLength = props.maxLength,
    maxLength = _props$maxLength === void 0 ? 99999999 : _props$maxLength,
    showCount = props.showCount,
    showlengthtips = props.showlengthtips,
    _props$showpasswordey = props.showpasswordeye,
    showpasswordeye = _props$showpasswordey === void 0 ? true : _props$showpasswordey,
    _props$chinesebyte = props.chinesebyte,
    chinesebyte = _props$chinesebyte === void 0 ? 1 : _props$chinesebyte,
    _props$numberbyte = props.numberbyte,
    numberbyte = _props$numberbyte === void 0 ? 1 : _props$numberbyte,
    _props$otherbyte = props.otherbyte,
    otherbyte = _props$otherbyte === void 0 ? 1 : _props$otherbyte,
    min = props.min,
    max = props.max,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? function () {} : _props$onChange;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShowPassword = _useState2[0],
    setIsShowPassword = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    valueS = _useState4[0],
    setValues = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    valueLength = _useState6[0],
    setValueLength = _useState6[1];
  var _useState7 = useState(0),
    _useState8 = _slicedToArray(_useState7, 2),
    verifyReg = _useState8[0],
    setVerifyReg = _useState8[1]; // 0、无校验  1、校验成功  2、校验失败

  useEffect(function () {
    if (value) {
      computeLength(value);
    } else {
      setValueLength(0);
      setValues(undefined);
    }
  }, [value]);

  /**
   * 修改
   */
  var handleChange = function handleChange(e, values) {
    var inputValue = '';
    if (e) {
      var _value = e.target.value;
      inputValue = _value;
      setValues(inputValue);
    } else {
      inputValue = values;
    }
    if (!isComposition) {
      var pattern = reg ? reg : regTypes[regtype];
      if (pattern) {
        if (canLimitInput.includes(regtype)) {
          inputValue = inputValue.replace(pattern, '');
        } else {
          var regExp = new RegExp(pattern);
          if (regExp.test(inputValue)) {
            setVerifyReg(1);
          } else {
            setVerifyReg(2);
          }
        }
        computeLength(inputValue);
        return;
        // onChange(inputValue);
      }

      computeLength(inputValue);
    }
  };

  /**
   * 计算长度
   */
  var computeLength = function computeLength(value) {
    var sum = 0;
    var tempStr = '';
    for (var _key in value) {
      if (value[_key].replace(/[^\d]/g, '')) {
        // 数据只留下数字 计算长度
        sum += numberbyte;
      } else if (value[_key].replace(/[^\u4e00-\u9fa5]/g, '')) {
        // 数据只留下汉字 计算长度
        sum += chinesebyte;
      } else {
        // 计算一下 其他的长度
        sum += otherbyte;
      }
      tempStr += value[_key];
      // 有长度限制
      if (maxLength && sum >= maxLength) {
        setValueLength(sum);
        setValues(tempStr);
        onChange(tempStr);
        return;
      }
    }
    setValueLength(sum);
    setValues(tempStr);
    onChange(tempStr);
  };

  /**
   * 失去焦点操作
   * @param e
   */
  var handleBlur = function handleBlur(e) {
    if (max && max < e.target.value) {
      setValues(max + '');
      onChange(max + '');
      return;
    }
    if (min && min > e.target.value) {
      setValues(min + '');
      onChange(min + '');
      return;
    }
    setValues(e.target.value);
    onChange(e.target.value);
  };

  /**
   * 监控
   * @param e
   */
  var handleComposition = function handleComposition(e) {
    if (e.type === 'compositionend') {
      isComposition = false;
      handleChange(null, valueS);
    } else {
      isComposition = true;
    }
  };
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    theme: {
      token: antd
    }
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Input, _extends({
    onBlur: handleBlur,
    status: verifyReg === 2 ? 'error' : ''
  }, props, {
    value: valueS,
    style: _objectSpread(_objectSpread({}, style), {}, {
      borderRadius: njoyd.borderRadius || antd.borderRadius
    }),
    showCount: showlength ? false : showCount,
    type: isShowPassword ? 'text' : props.type,
    suffix: suffix ? suffix : /*#__PURE__*/React.createElement(Space, null, showlength && maxLength && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
      className: classNames('count-color-1', {
        red: showlengthtips && valueLength >= (maxLength || 0)
      })
    }, valueLength, " / ", maxLength)), props.type === 'password' && /*#__PURE__*/React.createElement(React.Fragment, null, showpasswordeye && /*#__PURE__*/React.createElement(React.Fragment, null, !isShowPassword ? /*#__PURE__*/React.createElement(EyeInvisibleOutlined, {
      className: "eye-color",
      onClick: function onClick() {
        return setIsShowPassword(true);
      }
    }) : /*#__PURE__*/React.createElement(EyeOutlined, {
      className: "eye-color",
      onClick: function onClick() {
        return setIsShowPassword(false);
      }
    })))),
    onChange: handleChange,
    onCompositionStart: handleComposition,
    onCompositionEnd: handleComposition
  })), verifyReg === 2 && /*#__PURE__*/React.createElement("div", {
    className: "verify-tips"
  }, regtips ? regtips : verifyTips[regtype] || '')));
};
export default NjInput;